/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getDeathCertificateList = (
  payload = { sort_by: 'asc' },
  callback
) =>
  req.list(
    c.GET_DEATH_CERTIFICATE,
    '/api/v1/administrators/death_certificate_records',
    payload,
    callback
  );

export const getImage = (payload, callback) =>
  req.item(
    c.GET_IMAGE,
    `/api/v1/administrators/death_certificates/transaction_histories/photo`,
    callback,
    payload
  );

export const showDeathCertificate = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_USER_MANAGEMENT,
    `/api/v1/administrators/death_certificate_records/${id}`,
    payload,
    callback
  );

export const createDeathCertificate = (payload, callback) =>
  req.upload(
    c.CREATE_USER_MANAGEMENT,
    '/api/v1/administrators/death_certificate_records',
    payload,
    (data) => {
      if (callback) callback(data);
    }
  );

export const uploadNewImage = (id, payload, callback) =>
  req.upload(
    c.UPLOAD_NEW_IMAGE,
    `/api/v1/administrators/death_certificate_records/${id}/images`,
    payload,
    callback
  );

// export const updateNewImage = (id, imgId, payload, callback) =>
//   req.upload(
//     c.UPLOAD_NEW_IMAGE,
//     `/api/v1/administrators/death_certificate_records/${id}/images/${imgId}`,
//     payload,
//     callback
//   );

export const updateNewImage = (id, payload, callback) =>
  req.upload(
    c.UPLOAD_NEW_IMAGE,
    `/api/v1/administrators/death_certificate_records/${id}`,
    payload,
    (data) => {
      if (callback) callback(data);
    }
  );

export const updateDeathCertificate = (id, payload, callback) =>
  req.update(
    c.UPDATE_USER_MANAGEMENT,
    `/api/v1/administrators/death_certificate_records/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const syncToEs = (payload, callback) =>
  req.create(
    c.SYNC_TO_ES,
    `/api/v1/administrators/dc_record_sync_to_es`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeUserManagement = (id, payload, callback) =>
  req.remove(
    c.REMOVE_USER_MANAGEMENT,
    `/api/v1/administrators/death_certificate_records/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Remove !');
      if (callback) callback();
    }
  );

export const getRoleList = (
  payload = { is_paginated: 1, sort_by: 'asc' },
  callback
) =>
  req.list(c.GET_ROLE_LIST, '/api/v1/administrators/roles', payload, callback);

export const getRegionsList = (payload, callback) =>
  req.list(
    c.GET_REGION,
    '/api/v1/administrators/address/regions',
    payload,
    callback
  );

export const getProvinceList = (payload, callback) =>
  req.list(
    c.GET_PROVINCE,
    '/api/v1/administrators/address/provinces',
    payload,
    callback
  );

export const getMunicipalityList = (payload, callback) =>
  req.list(
    c.GET_MUNICIPALITIES,
    '/api/v1/administrators/address/municipalities',
    payload,
    callback
  );

export const getBarangayList = (payload, callback) =>
  req.list(
    c.GET_BARANGAYS,
    '/api/v1/administrators/address/barangays',
    payload,
    callback
  );
